import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from '@tanstack/react-router'
import { z } from 'zod'
import { hasAbility } from '@/lib/rbac'
import { PhoneRequestsPage } from '@/components/phone-requests/phone-requests-page'

export const phoneRequestProviderFilterValues = [
  'all',
  'masip',
  'didww',
  'twilio',
] as const

export const phoneRequestStatusFilterValues = [
  'all',
  'pending',
  'pending_signature',
  'purchased',
  'failed',
] as const

const defaultValues = {
  page: 0,
  provider: 'all' as const,
  status: 'all' as const,
}

export const phoneRequestsSearchSchema = z.object({
  page: z
    .number()
    .int()
    .min(0)
    .default(defaultValues.page)
    .catch(defaultValues.page),
  cursor: z.string().nullable().optional(),
  q: z.string().optional(),
  history: z.string().optional(),
  provider: z
    .enum(phoneRequestProviderFilterValues)
    .default(defaultValues.provider)
    .catch(defaultValues.provider),
  status: z
    .enum(phoneRequestStatusFilterValues)
    .default(defaultValues.status)
    .catch(defaultValues.status),
  country: z.string().optional(),
  accountId: z.string().optional(),
  accountName: z.string().optional(),
})

export const Route = createFileRoute('/_auth/_main-layout/phone-requests')({
  beforeLoad: () => {
    if (!hasAbility('manage_phones')) {
      throw redirect({ to: '/accounts' })
    }
  },
  component: PhoneRequestsPage,
  validateSearch: phoneRequestsSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
})
